<script lang="ts">
    import Vue from "vue";
    import { Component } from 'vue-facing-decorator';
    import { AlternativeFilterReadModel } from "@Alternatives/AlternativesViews/Domain/readmodels";
    import { AlternativeStatusReadModel } from "@Alternatives/Statuses/Domain/readmodels";

    @Component({
        props: {
            propRm: { type: Object, required: true },
            propStatuses: { type: Array, required: true }
        }
    })
    export default class StatusFilter extends Vue
    {
        get rm(): AlternativeFilterReadModel { return this.$props.propRm as AlternativeFilterReadModel; }
        get statuses(): AlternativeStatusReadModel[] { return this.$props.propStatuses as AlternativeStatusReadModel[]; }

        get headerText(): string | null
        {
            if (this.rm.Data.length == 0)
            {
                return "Invalid!";
            }

            const statuses = this.statuses.filter(a => this.rm.Data.indexOf(a.Name) !== -1).map(a => a.Name).sort();

            if (this.rm.Type === "StatusIn")
            {
                return `Status: ${statuses.join(", ")}`;
            }
            else if (this.rm.Type === "StatusNotIn")
            {
                return `Status not in: ${statuses.join(", ")}`;
            }

            return null;
        }

        deleteFilter()
        {
            this.$emit('deleteFilter', this.rm);
        }
    }
</script>

<template>
    <div class="card" style="display: inline-block;">
        <div @click="rm.IsEdited = true" class="card-header pointer">
            {{headerText}}
        </div>
        <div v-if="rm.IsEdited" class="card-body">
            <div class="form-group">
                <label>Statuses:</label>
                <select class="form-control" multiple size="6" v-model="rm.Data">
                    <option v-for="s in statuses" :value="s.Name">{{ s.Name }}</option>
                </select>
            </div>
            <div class="d-flex justify-content-between">
                <div class="dropdown d-inline">
                    <button type="button" class="btn btn-outline-danger" data-toggle="dropdown">
                        Delete
                    </button>
                    <div class="dropdown-menu">
                        <div class="btn-group">
                            <button type="button" class="btn btn-outline-secondary">Cancel</button>
                            <button @click="deleteFilter" type="button" class="btn btn-danger">Confirm</button>
                        </div>
                    </div>
                </div>

                <button @click="rm.IsEdited = false" class="btn btn-primary">Update</button>
            </div>
        </div>
    </div>
</template>      


<style scoped>
</style>